
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaSkipNextGoogleF as ObiMediaSkipNextGoogleFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-skip-next-google-f.js';
 
 
 

 
 export const ObiMediaSkipNextGoogleF = createComponent({
   react: React,
   tagName: 'obi-media-skip-next-google-f',
   elementClass: ObiMediaSkipNextGoogleFElement,
   events: {
     
   }
  });
 
 